import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getOSHData } from '../../../api';

class InternationalProgrammesReport extends Component
{
    constructor(props){
        super(props);
        this.state = {
            matrixPageData: [],
            isFetching: false,
        }
    }

    getData = () => {
        try {
            getOSHData('INTERNATIONAL_PROGRAMMES')
                .then((res) => {
                    this.setState({ matrixPageData: res.resultset })
                })
        } catch (error) {
            console.log('Error fetching data', error)
        } finally {
            this.setState({ ...this.state, isFetching: false })
        }
    }

    componentDidMount(){
        this.setState({ ...this.state, isFetching: true });
        this.getData();
    }

    getProgrammeRegion = (data, index) => {
        let realIndex = index != 0 ? index-1 : 0 ;
        if(data.check1 === true && (this.state.matrixPageData[realIndex].check1 != true || (realIndex === 0 && index === 0))){
            return <h3>{this.props.literals.L20525}</h3>
        }else if(data.check2 === true && this.state.matrixPageData[realIndex].check2 != true){
            return <h3>{this.props.literals.L20526}</h3>
        }
    }

    render(){
        return (
            <div>
                {
                    this.state.matrixPageData.length <= 0 ? (
                        <span>{this.props.literals.L20706}</span>
                    ) : ""
                }
                {
                    this.state.matrixPageData.map((data, index) => (
                        <div className={`clearfix international-programmes-items item-`+index} key={index}>                            
                            <div className="matrix--content--elements">
                                { this.getProgrammeRegion(data, index) }
                                <div className="box-rounded">
                                    <p className="institution-name">
                                        {ReactHtmlParser(this.props.literals["L"+data.text1])}
                                    </p>
                                    <div>
                                        {ReactHtmlParser(this.props.literals["L"+data.text2])}
                                    </div>
                                    <div className="text">
                                        {ReactHtmlParser(this.props.literals["L"+data.text3])}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}

export default InternationalProgrammesReport;